export default {
    fund: [{
            "title": "以下属于基金的绝对收益归因的是（　　）。",
            "questions": "I. 考查各个因素对基金总收益的贡献<br>II. 分析资产配置效应与证券选择效应<br>III. 分析基金跑赢或跑输业绩比较基准的原因<br>IV. 假设在考察区间内没有交易行为，每个证券的贡献为自身的收益率乘以其初始权重",
            "question": "A. II\nB. I、IV\nC. III、IV\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查绝对收益归因的概念。"
        },
        {
            "title": "关于基金公司投资交易流程，以下表述错误的是（　　）。",
            "question": "A. 投资部在投资组合构建及执行过程中，无需对投资组合的潜在风险进行充分评估并制定风险预案\nB. 交易员接收到指令后有权限根据自身对市场的判断选择合适时机完成交易\nC. 基金公司投资交易流程包括形成投资策略，构建投资组合，执行交易命令，绩效评估与组合调整、风险控制等环节\nD. 交易系统或相关负责人审核投资指令（价格数量）的合法合规性，违规指令将被拦截反馈给基金经理",
            "answer": "A",
            "explain": "本题考查投资交易流程。"
        },
        {
            "title": "在通常情况下投资标的流动性最差的是（　　）。",
            "question": "A. 沪深300ETF\nB. 短期国债\nC. 非上市公司股权\nD. 交易所隔夜回购",
            "answer": "C",
            "explain": "本题考查各类投资标的的流动性。"
        },
        {
            "title": "某基金的投资目标是通过挖掘存在于各相关证券子市场以及不同金融工具间的投资机会，灵活配置资产，并充分提高基金资产的使用效率，在实现基金资产保值基础上获取更高的投资收益，则该基金属于（　　）。",
            "question": "A. 主动投资基金\nB. 被动投资基金\nC. 指数投资基金\nD. 股票型基金",
            "answer": "A",
            "explain": "本题考查主动投资的概念。"
        },
        {
            "title": "某种零息债券的面额为100元，贴现率为4%，到期时间为180天，用DCF估值法计算，内在价值最接近（　　）元。",
            "question": "A. 98.69\nB. 99.05\nC. 98\nD. 99",
            "answer": "C",
            "explain": "本题考查零息债券估值法。"
        },
        {
            "title": "如果某债券基金的修正久期是2年，当市场利率下降0.1%，该债券基金的净资产将（　　）。",
            "question": "A. 无法确定\nB. 不变\nC. 减少0.2%\nD. 增加0.2%",
            "answer": "D",
            "explain": "本题考查修正久期。"
        },
        {
            "title": "关于投资组合管理的执行步骤，以下表述错误的是（　　）。",
            "question": "A. 当投资者的自身情况相比平时发生了变化，投资经理有可能会调整资产配置以适应该变化\nB. 投资执行是指确定并量化投资者的投资目标和投资限制，制定投资政策说明书，形成资本市场预期，建立战略资产配置\nC. 在进行投资决策时，投资经理会进行投资组合优化\nD. 投资经理有时会特意让投资组合的实际资产配置临时偏离其战略配置",
            "answer": "B",
            "explain": "本题考查投资组合管理的执行步骤。"
        }, {
            "title": "关于公募基金利润分配，以下表述正确的是（　　）。",
            "questions": "I. 货币市场基金可在基金合同中约定收益分配方式为红利再投资<br>II. 当日申购的货币市场基金即日享有基金的分配权益<br>III. 现金分红是开放式基金分红采取的最普遍的形式<br>IV. 开放式基金收益默认为采用分红再投资形式",
            "question": "A. II、III\nB. I、III\nC. I、II、IV\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查基金利润分配。"
        },
        {
            "title": "以下不属于投资政策说明书内容的是（　　）。",
            "question": "A. 投资限制\nB. 业绩比较基准\nC. 投资回报率目标\nD. 收益承诺",
            "answer": "D",
            "explain": "本题考查投资政策说明书的内容。"
        },
        {
            "title": "以下不属于风险敏感性指标的是（　　）。",
            "question": "A. MACD\nB. 久期\nC. 凸性\nD. β系数",
            "answer": "A",
            "explain": "本题考查风险敏感性指标。"
        },
        {
            "title": "关于企业的现金流量结构，以下说法正确的是（　　）。",
            "question": "A. 企业的利润好就会有充足的现金流\nB. 在企业的起步、成长、成熟、衰退等不同周期阶段，企业现金流量模式相同\nC. 新兴、快速成长的企业，其经营活动产生的现金流量必然为正，融资活动产生的净现金流量必定为负\nD. 企业现金流量结构可以反映企业的不同发展阶段",
            "answer": "D",
            "explain": "本题考查现金流量表。"
        },
        {
            "title": "基金准备投资3年期债券100万元，年利率为5%，复利计算，若第一年的利息为5万元，则第2年的利息为（　　）。",
            "question": "A. 5万元\nB. 15.76万元\nC. 10.25万元\nD. 5.25万元",
            "answer": "D",
            "explain": "本题考查复利的计算。"
        },
        {
            "title": "下列关于可赎回债券和可回售债券的论述中，正确的是（　　）。",
            "question": "A. 可回售条款降低了债券投资者的风险\nB. 可赎回条款不利于债券发行人\nC. 可赎回条款是债券投资者的权利\nD. 与其他属性相同但没有回售条款的债券相比，可回售债券的利率更高",
            "answer": "A",
            "explain": "本题考查可赎回条款和可回售条款的概念。"
        }, {
            "title": "银行间债券市场的债券结算和交收方式中，结算效率较高，结算本金风险较小的是（　　）。",
            "question": "A. 实时全额结算\nB. 批量全额结算\nC. 批量净额结算\nD. 实时净额结算",
            "answer": "A",
            "explain": "本题考查实时全额结算。"
        },
        {
            "title": "关于自上而下的股票投资组合构建策略，以下表述错误的是（　　）。",
            "question": "A. 可以进行积极的版块轮换，从而获得版块的差额收益\nB. 可以利用基本面分析深入研究个股的投资价值，挑选出企业业绩突出的股票获得收益\nC. 可以通过积极的网格调整，例如转换价值股和成长股的比例，追求风格收益\nD. 可以通过研究和预测决定经济形势的核心变量，来决定大类资产配置",
            "answer": "B",
            "explain": "本题考查股票投资组合构建。"
        },
        {
            "title": "债券的（　　）又叫违约风险，是指债券发行人未按照契约的规定支付债券的本金和利息，给债券投资者带来损失的可能性。",
            "question": "A. 信用风险\nB. 利率风险\nC. 通胀风险\nD. 流动性风险",
            "answer": "A",
            "explain": "本题考查债券信用风险的概念。"
        },
        {
            "title": "某债券基金的投资人赎回了净值1000万元的基金份额，并支付了0.5%的赎回费。根据该基金合同，该笔赎回费的50%计入基金资产。假定该笔赎回费未发生手续费，则以下表述正确的是（　　）。",
            "question": "A. 基金获得投资收益2.5万元\nB. 基金获得其他收入2.5万元\nC. 基金获得利息收入2.5万元\nD. 基金获得非经常性收入2.5万元",
            "answer": "B",
            "explain": "本题考查基金收入来源。"
        },
        {
            "title": "某债券基金的投资人赎回了净值1000万元的基金份额，并支付了0.5%的赎回费。根据该基金合同，该笔赎回费的50%计入基金资产。假定该笔赎回费未发生手续费，则以下表述正确的是（　　）。",
            "question": "A. 基金获得投资收益2.5万元\nB. 基金获得其他收入2.5万元\nC. 基金获得利息收入2.5万元\nD. 基金获得非经常性收入2.5万元",
            "answer": "B",
            "explain": "本题考查基金收入来源。"
        },
        {
            "title": "A公司的报表编制过程中，会计人员发现一笔当期发生的应收账款未计入，因此减少100万元现金，增加100万元应收账款。在各报表其他项目不变的情况下，以下说法正确的是（　　）。",
            "question": "A. A公司经营活动产生的现金流减少100万元\nB. A公司资产负债表中资产增加100万元\nC. A公司资产负债表中资产减少100万元\nD. A公司利润减少100万元",
            "answer": "A",
            "explain": "本题考查资产负债表的构成。"
        }, {
            "title": "以下的机构中不参与到银行间债券交易的是（　　）。",
            "question": "A. 中央国债登记结算有限责任公司\nB. 全国银行间同业拆借中心\nC. 上海清算所\nD. 中国证券登记结算有限责任公司",
            "answer": "D",
            "explain": "本题考查银行间债券交易的参与者。"
        },
        {
            "title": "QDII是在人民币没有实现可自由兑换、资本项目尚未开发的情况下，有限度的允许境内投资者投资境外市场的一项过渡性制度安排。目前，以下哪个机构不可以发行代客境外理财产品（　　）。",
            "question": "A. 商业银行\nB. 基金管理公司\nC. 财务公司\nD. 券商公司",
            "answer": "C",
            "explain": "本题考查可以发行代客境外理财产品的机构。"
        },
        {
            "title": "关于风险调整后收益指标，以下表述错误的是（　　）。",
            "question": "A. 詹森α只能针对相同风险等级的基金进行比较\nB. 夏普比率可能会产生错误的评价结论\nC. 特雷诺比率是无风险收益到投资组合收益两点间直线的斜率\nD. 信息比率越小，在同样的超额收益水平下跟踪误差越小",
            "answer": "D",
            "explain": "本题考查风险调整后收益指标。"
        },
        {
            "title": "投资者与证券公司之间的股票收益互换的模式不包括（　　）。",
            "question": "A. 股票收益和股票收益互换\nB. 股票收益和浮动利率的互换\nC. 股票收益和固定利率的互换\nD. 固定利率和股票收益的互换",
            "answer": "B",
            "explain": "本题考查股票收益互换。"
        },
        {
            "title": "关于权益类证券投资风险收益，以下表述错误的是（　　）。",
            "question": "A. 无论是系统风险还是非系统风险，都要求相应的风险溢价\nB. 风险资产期望收益率=风险资产收益率+风险溢价\nC. 风险较高的公司对应较高的风险溢价，其期望收益一般也较高\nD. 在其他条件都相同的情况下，股票投资者对风险更高的公司出价更低，要求的期望收益率更高",
            "answer": "B",
            "explain": "本题考查权益类证券投资的风险收益。"
        },
        {
            "title": "一定数量的交易订单迅速成交时会对市场价格造成影响，这种市场价格与交易没有下达时市场可能的价格之间的差额，被称为（　　）。",
            "question": "A. 冲击成本\nB. 延迟成本\nC. 买卖价差\nD. 机会成本",
            "answer": "A",
            "explain": "本题考查冲击成本的种类。"
        },
        {
            "title": "根据资本资产定价模型，市场价格偏高的证券将会（　　）。",
            "question": "A. 位于资本市场线下方\nB. 位于资本市场线上方\nC. 位于证券市场线上方\nD. 位于证券市场线下方",
            "answer": "D",
            "explain": "本题考查资本资产定价模型。"
        }, {
            "title": "预期损失的优势体现在以下哪些方面（　　）。",
            "questions": "I. 风险敏感性质量<br>II. 尾部风险度量<br>III. 风险因子收益<br>IV. 次可加性",
            "question": "A. I、II\nB. I、III\nC. II、IV\nD. II、III",
            "answer": "C",
            "explain": "本题考查预期损失的优势。"
        },
        {
            "title": "某ETF基金为了计算每日的头寸风险，选择了100个交易日的每日基金净值变化的基点值(单位:点)，并从小到大排列依次为-23.44,-22.91,-18.33,-17.11,-9.50，则的下3.5%分位数是（　　）。",
            "question": "A. -17.72\nB. -17.11\nC. -18.33",
            "answer": "A",
            "explain": "本题考查上分位数的计算分位数。"
        },
        {
            "title": "在整个银行间债券市场体系中，履行监督管理职责的机构是（　　）。",
            "question": "A. 中国结算公司\nB. 中国人民银行\nC. 中国银监会\nD. 全国银行间商业拆借中心",
            "answer": "B",
            "explain": "本题考查银行间债券市场的组织体系。"
        },
        {
            "title": "下列有关β系数中，说法正确的是（　　）。",
            "questions": "I. CAPM利用希腊字母贝塔(β)来描述资产或资产组合的系统风险大小<br>II. β系数，可以理解为资产对市场收益变动的敏感性<br>III. β系数越大的股票，在市场波动的时候，其收益的波动越小<br>IV. 一个资产或资产组合的β系数越高，则它的预期收益率越高",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查CAPM模型的主要思想和应用。"
        },
        {
            "title": "下列不属于大宗商品投资方式的是（　　）。",
            "question": "A. 投资能源类企业发行的债券\nB. 投资大宗商品ETF\nC. 购买大宗商品相关的股票\nD. 购买大宗商品实物",
            "answer": "A",
            "explain": "本题考查大宗商品的投资方式。"
        },
        {
            "title": "对于金融市场，以下事件中不属于非系统性风险的是（　　）。",
            "question": "A. 由于公司核算账户资金差错，造成货币资金多记299.44元\nB. 由于受到几十年一遇异常冷水团，公司投资的虾和扇贝绝收\nC. 由于资金紧张，饲料供应不及时，公司生猪养殖死亡率高于预期\nD. “蒜”你狠，“姜”你军使相关货物的水平上扬",
            "answer": "D",
            "explain": "本题考查非系统性风险。"
        }, {
            "title": "企业的流动资产不包括（　　）。",
            "question": "A. 应收账款\nB. 存货\nC. 应收票据\nD. 预收账款",
            "answer": "D",
            "explain": "本题考查资产负债表的组成部分。"
        },
        {
            "title": "投资者于周五交易时间内申购了某每日进行收益分配的货币市场基金，则基金为其计算权益是从（　　）开始，投资者于周五交易时间内赎回了某每日进行收益分配的货币市场基金，则基金为其计算权益到（　　）结束。",
            "question": "A. 本周五；本周日\nB. 下周一；本周五\nC. 本周五；下周一\nD. 下周一；本周日",
            "answer": "D",
            "explain": "对于普通的货币市场基金品种，投资者于周五申购或转换转入的基金份额不享有周五和周六、周日的利润；投资者于周五赎回或转换转出的基金份额享有周五和周六、周日的利润。"
        },
        {
            "title": "基金管理人对基金资产估值后，下一步程序应将基金份额净值结果（　　）。",
            "question": "A. 发给基金注册登记机构用于计算申购、赎回数额\nB. 直接对外公布\nC. 发给基金托管人复核\nD. 直接发给基金注册登记机构计算申购、赎回数额",
            "answer": "C",
            "explain": "本题考查基金资产的估值程序。"
        },
        {
            "title": "《货币市场基金监督管理办法》的最新规定要求货币市场基金投资组合的平均剩余期限不得超过（　　）天，平均剩余存续期不得超过（　　）天。",
            "question": "A. 120; 240\nB. 180; 360\nC. 90; 180\nD. 60; 120",
            "answer": "A",
            "explain": "本题考查衡量货币基金风险指标的相关规定。"
        },
        {
            "title": "关于股票基金的风险管理，以下表述错误的是（　　）。",
            "question": "A. 股票基金系统性风险管理的要点，在于控制基金投资经理在该股票组合系统性风险的暴露是否符合投资方针的规定\nB. 某股票基金的股东数大于1，说明该基金是一个稳定或防御型基金\nC. 股票基金如要降低其非系统性风险，可以通过分散投资来实现\nD. 常用来反映股票基金风险的指标有标准差、β系数、持股集中度、持股数量和行业投资集中度等",
            "answer": "B",
            "explain": "本题考查股票基金的风险管理。"
        },
        {
            "title": "当把所有具有相同收益率的组合进行比较时，可行集（　　）组合具有更低的风险。",
            "question": "A. 最下边\nB. 最上边\nC. 最左边\nD. 最右边",
            "answer": "C",
            "explain": "本题考查最小方差前沿。"
        },
        {
            "title": "无风险资产与风险资产的相关系数为（　　）。",
            "question": "A. 0\nB. 1\nC. -1\nD. 0.5",
            "answer": "A",
            "explain": "本题考查相关系数的概念。"
        }, {
            "title": "以下属于货币市场工具的是（　　）。",
            "question": "A. 1年银行大额存单\nB. 到期时间为半年的短期高风险企业债券\nC. 到期时间为2年的五年期国债\nD. 交割期为3个月的国债期货",
            "answer": "A",
            "explain": "本题考查常用的货币市场工具。"
        },
        {
            "title": "关于沪深300指数，以下表述错误的是（　　）。",
            "question": "A. 以2004年12月31日为基期，基点为1000点\nB. 沪深300价格指数实时发布，全收益指数每日收盘后发布\nC. 由中证指数有限公司编制\nD. 以总股本为权重，采用几何平均法计算",
            "answer": "D",
            "explain": "本题考查沪深300指数的概念。"
        },
        {
            "title": "关于另类投资的内涵，以下表述错误的是（　　）。",
            "question": "A. 另类投资通常被认为是传统投资之外的所有投资\nB. 另类投资等同于创新投资\nC. 另类投资的另类体现在投资标的、投资策略和投资的组织形式上\nD. 另类投资是能够在可接受的风险水平下提供合理回报的投资",
            "answer": "B",
            "explain": "A选项表述正确，另类投资无明确定义，通常被认为是传统投资之外的所有投资。"
        },
        {
            "title": "中央结算公司在银行债券交易中提供的服务主要是（　　）。",
            "question": "A. 监督债券市场运行\nB. 担任做市商角色\nC. 交易结算功能\nD. 提供交易平台",
            "answer": "C",
            "explain": "本题考查中央结算公司的功能。"
        },
        {
            "title": "相对封闭式基金，开放式基金特有的财务会计报表分析内容是（　　）。",
            "question": "A. 持仓结构分析\nB. 投资风格分析\nC. 分红能力分析\nD. 份额变动分析",
            "answer": "D",
            "explain": "本题考查开放式基金特有的财务会计报告分析内容。"
        },
        {
            "title": "关于货币市场基金，以下表述正确的是（　　）。",
            "questions": "I. 货币市场基金可以投资剩余存续期小于397天，但剩余期限超过397天的浮动利率债券<br>II. 浮动利率债券可参考回购利率作为基准利率<br>III. 货币市场基金的杠杆风险通常比债券基金低<br>IV. 通常采用摊余成本法进行估值核算",
            "question": "A. II、III\nB. II、III、IV\nC. I、II、IV\nD. III、IV",
            "answer": "B",
            "explain": "本题考查货币市场基金。"
        }, {
            "title": "纽约商品交易所的轻质原油是哪类大宗商品（　　）。",
            "question": "A. 基础原材料类大宗商品\nB. 能源类大宗商品\nC. 农产品类大宗商品\nD. 贵金属类大宗商品",
            "answer": "B",
            "explain": "本题考查能源类大宗商品。"
        },
        {
            "title": "若没有预期的变现需求，投资者可以适当（　　）流动性要求，以（　　）预期收益。",
            "question": "A. 降低、提高\nB. 降低、降低\nC. 提高、提高\nD. 提高、降低",
            "answer": "A",
            "explain": "本题考查流动性。"
        },
        {
            "title": "基金在场内进行投资交易，需要支付的交易结算费用中不包括（　　）。",
            "question": "A. 经手费\nB. 证券交易所交易监管费\nC. 过户费\nD. 中购顾问费",
            "answer": "D",
            "explain": "本题考查基金交易费的内容。"
        },
        {
            "title": "关于半强有效市场，以下表述错误的是（　　）。",
            "question": "A. 通过对公司年报信息进行分析是无效的\nB. 通过对历史股价、成交量等信息进行的技术分析是无效的\nC. 内幕交易者可能通过分析内幕信息来获取非法收益\nD. 通过对公司股票分析、公司并购等公告信息进行分析是有效的",
            "answer": "D",
            "explain": "本题考查半强有效市场。"
        },
        {
            "title": "根据2014年《公开募集证券投资基金运作管理办法》的规定，下列符合混合型基金的要求的是（　　）。",
            "question": "A. 股票投资比例:65%-80%\nB. 股票投资比例:80%-95%\nC. 股票投资比例:85%-100%\nD. 股票投资比例:0-2%，债券投资比例80%以上",
            "answer": "A",
            "explain": "本题考查混合基金的投资比例。"
        },
        {
            "title": "债券价格与当期收益率的关系中，正确的是（　　）。",
            "question": "A. 债券当期收益率与到期收益率呈反向变动\nB. 对于平价交易的债券，当期收益率等于票面利率\nC. 对于折价交易的债券，当期收益率低于票面利率\nD. 对于溢价交易的债券，当期收益率高于票面利率",
            "answer": "B",
            "explain": "本题考查债券价格与当期收益率的关系。"
        },
        {
            "title": "以下关于预期损失的说法，正确的是（　　）。",
            "question": "A. 预期损失由于其在尾部风险度量、次可加性等方面的优势，越来越受到金融行业与监管机构的重视\nB. 预期损失不需要给定时间区间，是指在给定置信区间内投资组合损失的期望值\nC. 预期损失可以体现那些将来可能发生但没有在历史数据中体现的最大损失\nD. 预期损失是一个分位值，不能衡量最左侧区域的风险情况",
            "answer": "A",
            "explain": "本题考查预期损失的概念。"
        }, {
            "title": "交易所上市交易的债券一般按照哪一种价格进行估值（　　）。",
            "question": "A. 第三方估值机构提供的当日估值净值\nB. 成本价\nC. 交易所市价\nD. 交易所收盘价",
            "answer": "A",
            "explain": "本题考查交易所上市交易的非流通受限品种的估值。"
        },
        {
            "title": "关于债券的久期和凸性的属性，以下选项错误的是（　　）。",
            "question": "A. 久期和凸性是衡量信用利差变化特性的两个重要指标\nB. 价格---收益率曲线的曲率就是债券的凸性\nC. 价格---收益率曲线的斜率随着收益率而变化\nD. 对于债券收益的微小变化，久期可以给出利率敏感性测度",
            "answer": "A",
            "explain": "本题考查债券的久期和凸性。"
        },
        {
            "title": "某基金当日持有股票的市值为15亿元，债券市值10亿元，买入返售金融资产2亿元，应付的证券清算款3亿元。应付费用合计0.5亿元，银行存款为1亿元，假设无其他项目，则该基金当日的资产总值为（　　）亿元。",
            "question": "A. 31.5\nB. 28\nC. 24.5\nD. 26",
            "answer": "B",
            "explain": "基金资产总值即基金全部资产的价值总和。"
        },
        {
            "title": "关于基金管理人和基金托管人在基金会计核算中的职责，以下表述错误的是（　　）。",
            "question": "A. 基金管理人应当保证不同基金在名册登记、账户设置、资金划拨、账簿记录等方面相互独立\nB. 基金托管人应当按规定对基金管理人的会计核算进行复核并出具复核意见\nC. 基金管理人应当以每只基金为会计核算主体，独立建账、独立核算\nD. 基金托管人对所托管的基金进行独立会计核算，并将有关结果与基金管理人核对，对基金会计核算承担会计责任",
            "answer": "D",
            "explain": "本题考查基金会计主体。"
        },
        {
            "title": "下列关于零息债券的表述，错误的是（　　）。",
            "question": "A. 零息债券有固定到期日\nB. 零息债券在存续期内按期向债券持有人支付利息\nC. 零息债券折价发行\nD. 零息债券到期支付日的面值和发行时价格的差额即为投资者的收益",
            "answer": "B",
            "explain": "本题考查零息债券的概念。"
        },
        {
            "title": "以下选项中，用于确定投资组合收益来源的是（　　）。",
            "question": "A. 业绩度量\nB. 业绩评估\nC. 绩效评估\nD. 业绩归因",
            "answer": "D",
            "explain": "本题考查业绩归因的概念。"
        }, {
            "title": "我国场内股票交易产生过户费，其最终收取机构是（　　）。",
            "question": "A. 证券交易所\nB. 中国证监会\nC. 中国证券登记结算有限公司\nD. 证券结算风险基金",
            "answer": "C",
            "explain": "本题考查过户费的概念。"
        },
        {
            "title": "风险价值是指在给定的时间区间和给定的置信水平下，下列哪一个要素发生变化时，投资组合面临潜在最大损失（　　）。",
            "question": "A. 信用风险\nB. 流动性风险\nC. 市场风险\nD. 操作风险",
            "answer": "C",
            "explain": "本题考查风险价值的概念。"
        },
        {
            "title": "关于基金利润分配，以下说法错误的是（　　）。",
            "question": "A. 基金分红公告要包含收益分配方案、时间、发放办法等\nB. 开放式基金一定要进行利润分配\nC. 基金收益分配后净值不低于面值\nD. 封闭式基金每年至少一次收益分配",
            "answer": "B",
            "explain": "本题考查基金利润的分配。"
        },
        {
            "title": "股票价格看涨期权买入开仓的最大损失是（　　）。",
            "question": "A. 执行价格减去期权费\nB. 期权费\nC. 期权费加上执行价格\nD. 股票价格变动之差减去期权费",
            "answer": "B",
            "explain": "本题考查期权合约的价值。"
        },
        {
            "title": "某股票基金在2018年度平均净资产为10000万元，期间共买入股票7000万元，卖出股票3000万元。该基金在2018年的股票换手率为（　　）。",
            "question": "A. 0.3\nB. 0.7\nC. 0.5\nD. 1",
            "answer": "C",
            "explain": "本题考查股票换手率。"
        },
        {
            "title": "资本资产定价模型的基础是（　　）。",
            "question": "A. 法玛的有效市场假说\nB. 夏普的单一指数模型\nC. 套利定价模型\nD. 马可维茨证券组合理论",
            "answer": "D",
            "explain": "本题考查资本资产定价模型的基础理论。"
        }, {
            "title": "某私募基金经理分析一只信息科技股票，认为其近三个月价格下跌，但近一年的稳步上升形态并着股价下跌，成交量也在萎缩。他认为该股票只要跌幅不超过10%，就可以继续持有。请问他采",
            "question": "A. 技术分析\nB. 行业生命周期分析\nC. 相对内在价值分析\nD. 长短期结合的基本面分析",
            "answer": "A",
            "explain": "本题考查技术分析。"
        },
        {
            "title": "某投资组合的主动比重为（　　）时，意味着该投资组合与基准完全相同。",
            "question": "A. 100%\nB. 0\nC. 20%\nD. 50%",
            "answer": "B",
            "explain": "本题考查主动比重的意义。"
        },
        {
            "title": "信息比率越大，说明该基金在同样的跟踪误差水平上能获得（　　）的超额收益，或者在同样的超额收益水平下跟踪误差（　　）。",
            "question": "A. 更大；更小\nB. 更大；更大\nC. 更小；更大\nD. 更小；更小",
            "answer": "A",
            "explain": "本题考查信息比率与跟踪误差。"
        },
        {
            "title": "某15年期债券面值为1000美元，票息率为8%，该债券市场价值为800美元，则当前收益率为（　　）。",
            "question": "A. 10%\nB. 8%\nC. 5%\nD. 7.5%",
            "answer": "A",
            "explain": "本题考查当期收益率的计算。"
        },
        {
            "title": "关于市场有效性的标准及三个层次，以下表述正确的是（　　）。",
            "questions": "I. 依据时间维度，把信息划分为历史信息、当前公开可得信息以及内部信息<br>II. 三个层次的有效市场包括弱有效市场、半强有效市场及强有效市场<br>III. 如果证券市场是半强有效的，市场参与者就可以从公开信息中获取超额利润，意味着基本面分析有效<br>IV. 在弱有效证券市场，任何预测未来证券价格走势而对以往价格、交易量等历史信息进行的技术分析都是徒劳的",
            "question": "A. II、III\nB. I、II、III、IV\nC. I、II、IV\nD. III、IV",
            "answer": "C",
            "explain": "本题考查市场有效性的标准及三个层次。"
        },
        {
            "title": "某投资者买入A股票50000元，卖出B股票30000元，当前的证券交易印花税率为1%，则应缴纳的印花税金额是（　　）元。",
            "question": "A. 20\nB. 50\nC. 80\nD. 30",
            "answer": "D",
            "explain": "本题考查印花税。"
        }, {
            "title": "关于管理人基金会计核算的复核，以下表述正确的是（　　）。",
            "question": "A. 由基金托管人进行复核\nB. 基金管理人和托管人协调处理\nC. 由基金管理人自行复核即可\nD. 基金管理人和托管人互相复核",
            "answer": "A",
            "explain": "本题考查基金托管人的职责。"
        },
        {
            "title": "基金托管人对基金管理人的估值原则或程序有异议时，应（　　）。",
            "question": "A. 报告中国证监会\nB. 有义务要求基金管理公司做出合理解释\nC. 保有质询基金管理公司做出合理解释的权利\nD. 以基金管理公司的估值原则和程序为准，因为基金管理人是估值责任人，基金托管人根据基金管理原则和程序复核基金资产净值以及基金份额价格",
            "answer": "B",
            "explain": "本题考查估值责任人。"
        },
        {
            "title": "反转收益率曲线的期限结构特征是（　　）。",
            "question": "A. 短期债券收益率较高，而长期债券收益率较低\nB. 期限相对较短的债券，利率与期限呈正向关系而期限相对较长的债券，利率与期限呈反向关系\nC. 短期债券收益率较低，而长期债券收益率较高\nD. 长短期债券收益率基本相等",
            "answer": "A",
            "explain": "本题考查反转收益率曲线。"
        },
        {
            "title": "关于基金投资运作过程中的集中交易制度，以下理解正确的是（　　）。",
            "question": "A. 基金的投资决策职能与交易执行职能分别由基金经理与基金交易部门承担的\nB. 基金经理直接向交易员下达投资指令\nC. 基金经理直接进行交易\nD. 交易指令应包含确切的交易价格，交易员严格按照该价格水平进行证券交易",
            "answer": "A",
            "explain": "本题考查集中交易制度。"
        },
        {
            "title": "可转换债券对应的股票市场价格低于转化价值时，可转换债券的价值主要体现了（　　）的属性。",
            "question": "A. 固定收益类\nB. 权益类\nC. 期权\nD. 期货",
            "answer": "A",
            "explain": "本题考查可转换债券的价值。"
        },
        {
            "title": "目前，我国货币市场基金的管理费率一般不高于（　　）。",
            "question": "A. 0.5%\nB. 1.5%\nC. 0.33%\nD. 1%",
            "answer": "C",
            "explain": "本题考查货币市场基金管理费率的规定。"
        }, {
            "title": "境内机构投资者开展境外证券投资业务时，可以选择境外资产托管人负责境外资产托管业务，关于境外资产托管人所需满足的条件，以下表述正确的是（　　）。",
            "question": "A. 在中国大陆以外的国家或地区设立，最近一个会计年度实收资本不少于2亿美元或等值货币，或托管规模不少于2000亿美元或等值货币\nB. 在中国大陆以外的国家或地区设立，最近一个会计年度实收资本不少于10亿美元或等值货币，或托管规模不少于1000亿美元或等值货币\nC. 在中国大陆设立，最近一个会计年度实收资本不少于20亿美元或等值货币，或托管规模不少于2000亿美元或等值货币\nD. 在中国大陆设立，最近一个会计年度实收资本不少于10亿美元或等值货币，或托管规模不少于1000亿美元或等值货币",
            "answer": "B",
            "explain": "本题考查可以接受托管人委托负责境外资产托管业务的境外资产托管人的条件。"
        },
        {
            "title": "在其他因素相同的情况下，票面利率与到期收益率（　　）。",
            "question": "A. 反方向增减\nB. 两者之间变动没有关系\nC. 同方向增减\nD. 贴息债同方向增减，附息债反方向增加",
            "answer": "C",
            "explain": "本题考查票面利率与到期收益率的关系。"
        },
        {
            "title": "关于非系统性风险，以下表述错误的是（　　）。",
            "question": "A. 大多数资产价格变动方向往往是相反的\nB. 非系统性风险也可称作个体风险\nC. 负面新闻可能会导致投资组合的非系统性风险增加\nD. 投资组合中的资产数量越多，非系统性风险越小，直至接近于零",
            "answer": "A",
            "explain": "本题考查非系统性风险的概念。"
        },
        {
            "title": "市场风险不包括（　　）。",
            "question": "A. 利率风险\nB. 汇率风险\nC. 政策风险\nD. 合规风险",
            "answer": "D",
            "explain": "本题考查市场风险的种类。"
        },
        {
            "title": "2007年，证监会发布《关于实施<合格境内机构投资者境外证券投资管理试行办法>有关问题的通知》，关于（　　）。",
            "question": "A. QDII基金估值第一责任主体是QDII基金管理人\nB. QDII基金投资衍生品，应当在每个工作日计算并披露净值\nC. QDII基金投资流通受限的证券估值可以参照国际会计准则进行\nD. QDII基金份额净值应当在估值日后1个工作日披露",
            "answer": "D",
            "explain": "本题考查QDII基金估值。"
        },
        {
            "title": "某投资者于2019年3月4日买入债券质押式回购1000000元，期限为3天，回购利率为3%，则该投资者到期资金结算额（　　）元。",
            "question": "A. 1000245.90\nB. 1000250\nC. 1000246.58\nD. 1000240",
            "answer": "C",
            "explain": "本题考查质押式回购的到期资金结算额计算。"
        }, {
            "title": "通常而言，（　　）是收益率曲线的正常形态。",
            "question": "A. 下降曲线\nB. 垂直曲线\nC. 水平曲线\nD. 上升曲线",
            "answer": "D",
            "explain": "本题考查上升收益率曲线。"
        },
        {
            "title": "香港交易所正式修订上市规则，允许以下三类公司申请上市。<br>I. 未能通过主板财务资格测试的公司；<br>II. 拥有不同股权架构的公司；<br>III. 为寻求在香港作第二上市地的大中华及国际公司，其组织架构即俗称的同股不同权。同股不同权的权在这个语境下是指（　　）。",
            "question": "A. 分红权\nB. 表决权\nC. 知情权\nD. 清偿权",
            "answer": "B",
            "explain": "本题考查“同股不同权”的含义。"
        },
        {
            "title": "关于基金托管人的估值相关责任，以下表述正确的是（　　）。",
            "question": "A. 基金托管人和基金管理人都是基金资产估值的第一责任人\nB. 基金托管人对基金管理人的估值结果负有复核责任\nC. 基金托管人和基金管理人对基金估值技术存在分歧时，应以基金管理人的意见为主\nD. 基金托管人和基金管理人对基金估值技术存在分歧时，应以基金托管人的意见为主",
            "answer": "B",
            "explain": "本题考查估值责任人。"
        },
        {
            "title": "关于基金投资品种的估值方法，以下表述错误的是（　　）。",
            "question": "A. 对停止交易但未行权的权证，一般采用估值技术确定公允价值\nB. 因配股未上市的股票，按交易所上市同一股票市价\nC. 交易所上市交易的可转换债券按当日收盘价作为估值净价\nD. 交易所上市的股指期货合约以估值当日结算价进行估值",
            "answer": "C",
            "explain": "本题考查具体投资品种的估值方法。"
        },
        {
            "title": "关于私募股权投资的风险收益特征，以下表述正确的是（　　）。",
            "question": "A. 股权投资往往被认定为是具有中等风险的战略\nB. 风险投资被认为是私募股权投资中处于高风险领域的战略\nC. 投资私募股权的风险一般低于货币市场基金\nD. 并购投资通常具有收益波动性较低的特征",
            "answer": "B",
            "explain": "本题考查风险投资。"
        },
        {
            "title": "预期央行可能降息，在基金合同允许范围内，为提高债券基金的收益率，基金经理可能进行的操作有（　　）。",
            "questions": "I. 提高杠杆率<br>II. 降低杠杆率<br>III. 提高组合久期<br>IV. 降低组合久期",
            "question": "A. II、IV\nB. I、IV\nC. I、III\nD. II、III",
            "answer": "C",
            "explain": "本题考查债券投资组合构建。"
        }, {
            "title": "10年期国债期货合约最低交易保证金是合约价值的2%，则最多可以控制（　　）倍于所投资金额的合约资产。",
            "question": "A. 2\nB. 30\nC. 50\nD. 100",
            "answer": "C",
            "explain": "本题考查增指合约的杠杆性。"
        },
        {
            "title": "以下交易成本中，不属于隐性成本的是（　　）。",
            "question": "A. 买卖差价\nB. 冲击成本\nC. 交易佣金\nD. 机会成本",
            "answer": "C",
            "explain": "本题考查隐性成本的种类。"
        },
        {
            "title": "某基金年度平均收益率为20%，假设无风险收益率为3%(年化)，该基金的年化波动率为25%，贝塔系数为0.85，则该基金的特雷诺比率为（　　）。",
            "question": "A. 0.2\nB. 0.25\nC. 0.8\nD. 0.68",
            "answer": "A",
            "explain": "本题考查风险调整后收益。"
        },
        {
            "title": "投资组合A、B的主动比重分别为30%、60%，且A、B的基准指数相同，可以得出以下结论（　　）。",
            "question": "A. 市场上涨时，投资组合B一定会跑赢投资组合A\nB. 投资组合B与基准的表现差别可能比投资组合A与基准的表现差别大\nC. 市场上涨时，投资组合A一定会跑赢投资组合B\nD. 投资组合A与基准的相关性较投资组合B与基准的相关性要低",
            "answer": "B",
            "explain": "本题考查主动比重的概念。"
        },
        {
            "title": "个人投资者从基金分配中获得下列收入，目前需要征收个人所得税的是（　　）。",
            "question": "A. 股利收入\nB. 国债利息收入\nC. 定期存款利息收入\nD. 买卖股票差价收入",
            "answer": "A",
            "explain": "本题考查个人投资者需要征收所得税的项目。"
        },
        {
            "title": "某企业的经济附加值为1000万，资本收益率为18%，实际投入资本为1亿元，则其加权平均资本成本为（　　）。",
            "question": "A. 12%\nB. 10%\nC. 8%\nD. 28%",
            "answer": "C",
            "explain": "本题考查经济附加值(EVA)模型。"
        }, {
            "title": "某投资者将资金投向A、B、C三只股票，其占总资金的百分比分别为40%、30%、30%，股票A的期望收益率为18%，股票B的期望收益率为10%，股票C的期望收益率为5%，则投资者的股票组合期望收益率为（　　）。",
            "question": "A. 12.7%\nB. 11.7%\nC. 11.0%\nD. 10.7%",
            "answer": "B",
            "explain": "本题考查投资组合期望收益率的计算。"
        },
        {
            "title": "证券投资基金的会计报表通常不包括（　　）。",
            "question": "A. 资产负债表\nB. 现金流量表\nC. 利润表\nD. 净值变动表",
            "answer": "B",
            "explain": "本题考查基金会计报表。"
        },
        {
            "title": "关于可转换债券的转换价值，以下表述正确的是（　　）。",
            "question": "A. 当股价很高时，转换权利价值可能超过可转换债券价值\nB. 当股价低于转换价格时，转换权利价值为负\nC. 转换权利价值为可转换债券价值与纯粹债权价值的差额\nD. 当股价高于转换价格时，可转换债券价值等于转换权利价值",
            "answer": "C",
            "explain": "本题考查可转换债券的价值。"
        },
        {
            "title": "某投资者将资金投向A、B、C三只股票，其占总资金的百分比分别为40%、30%、30%，股票A的期望收益率为18%，股票B的期望收益率为10%，股票C的期望收益率为5%，则投资者的期望收益率为（　　）。",
            "question": "A. 12.7%\nB. 11.7%\nC. 11.0%\nD. 10.7%",
            "answer": "B",
            "explain": "本题考查投资组合期望收益率的计算。"
        },
        {
            "title": "证券投资基金的会计报表通常不包括（　　）。",
            "question": "A. 资产负债表\nB. 现金流量表\nC. 利润表\nD. 净值变动表",
            "answer": "B",
            "explain": "本题考查基金会计报表。"
        },
        {
            "title": "关于可转换债券的转换价值，以下表述正确的是（　　）。",
            "question": "A. 当股价很高时，转换权利价值可能超过可转换债券价值\nB. 当股价低于转换价格时，转换权利价值为负\nC. 转换权利价值为可转换债券价值与纯粹债权价值的差额\nD. 当股价高于转换价格时，可转换债券价值等于转换权利价值",
            "answer": "C",
            "explain": "本题考查可转换债券的价值。"
        },
        {
            "title": "（材料题）在同一时间内，基金甲的年化收益率是5%，年化波动率是8%，业绩比较基准为100%中债综合指数；基金乙的年化收益率为28%，业绩比较基准为90%中证500指数+10%同业存款利率。（1）以下说法正确的是（　　）。",
            "question": "A. 基金甲是绝对收益产品\nB. 基金甲是相对收益产品，基金乙是绝对收益产品\nC. 基金甲和乙都是绝对收益产品\nD. 基金甲和乙都是相对收益产品",
            "answer": "D",
            "explain": "本题考查相对收益。"
        },
        {
            "title": "（材料题）在同一时间内，基金甲的年化收益率是5%，年化波动率是8%，业绩比较基准为100%中债综合指数；基金乙的年化收益率为28%，业绩比较基准为90%中证500指数+10%同业存款利率。（2）假设无风险收益率为1%，则基金乙的夏普比率为（　　）。",
            "question": "A. 0.5\nB. 0.6\nC. 0.75\nD. 0.65",
            "answer": "C",
            "explain": "本题考查夏普比率的计算。"
        },
        {
            "title": "（材料题）在同一时间内，基金甲的年化收益率是5%，年化波动率是8%，业绩比较基准为100%中债综合指数；基金乙的年化收益率为28%，业绩比较基准为90%中证500指数+10%同业存款利率。（3）从投资者的角度，（　　）更适合低风险偏好投资者。",
            "question": "A. 基金甲\nB. 基金乙\nC. 基金甲和基金乙\nD. 无法判断",
            "answer": "A",
            "explain": "本题考查基金的风险指标。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-2.js